// Builds a browser-navigable (window.open / href) URL for executed
// contract copies. These endpoints render HTML so the SPA can't send an
// Authorization header — the backend accepts `?token=` instead
// (icma_contract_routes._resolve_bearer_or_query).
export const executedCopyHref = (url) => {
  if (!url) return '#';
  const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  const path = url.startsWith('/api/') ? url : `/api${url.startsWith('/') ? '' : '/'}${url}`;
  const tok = localStorage.getItem('token') || '';
  return `${base}${path}${path.includes('?') ? '&' : '?'}token=${encodeURIComponent(tok)}`;
};
